<template>
  <!-- 企业服务-其他服务-审计 -->
  <div class="Invoice-body">
    <!-- 筛选 -->
    <el-form
      :model="screenData"
      :inline="true"
      class="screen"
      @submit.native.prevent="handelSearch"
    >
      <el-form-item label="订单ID：">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.orderNumber" placeholder="请输入订单ID"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="企业类型：" class="user-Id">
      <div class="size-search">
      <el-select v-model="screenData.PayTaxes" placeholder="请选择企业类型">
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      >
      </el-option>
      </el-select>
      </div>
      </el-form-item>
      <el-form-item label="企业名称：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.input" placeholder="请输入企业名称"></el-input>
      </div>
      </el-form-item>
      <el-form-item label="统一社会信用代码：" class="user-Id">
      <div class="size-search">
      <el-input maxlength="30" v-model="screenData.code" placeholder="请输入统一社会信用代码"></el-input>
      </div>
      </el-form-item>
      
      <div class="screen-end">
      <el-form-item label="时间：" >
      <el-date-picker
      v-model="screenData.value"
      type="daterange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      unlink-panels
      clearable
      @clear="screenData.value = null"
      >
      </el-date-picker>
      </el-form-item>
      <el-form-item>
      <el-button type="primary" class="ser-btn public-style" @click="handelSearch">搜 索</el-button>
      <el-button class="heavy-btn public-style" @click="handelReset">重 置</el-button>
      </el-form-item>
      </div>
    
    </el-form>
    <!--  -->
    <div class="table-top-Controls">
      <div class="RemainingLocation">
        <el-button type="primary" class="action-btn firm-clickable" @click="handelUp">审计多家</el-button>
        <el-button type="primary" class="action-btn firm-clickable" @click="handelAndLeProcess">审计一家</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <div class="Table">
      <Table
        :tableData="tableData"
        :belongTo="'审计'"
        :pagingObj="pagingObj"
        @handelDetails="handelDetails"
        @handelAndLeProcess="handelAndLeProcess"
        @handelEvaluation="handelEvaluation"
        @Refresh="Refresh"
      ></Table>
    </div>
    <!-- 底部分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <!-- 办理 -->
    <HandlePro
      :enterprise="enterprise"
      :options1="options1"
      :VisibleHandlePro="VisibleHandlePro"
      @handleCloseHandlePro="VisibleHandlePro = false"
      @handleSuccess="handleSuccess"
    ></HandlePro>
    <!-- 上传 -->
    <UpEstablishment
      :VisibleUp="VisibleUp"
      @handleCloseUp="VisibleUp = false"
      @handleSuccess="handleSuccess"
    ></UpEstablishment>
    <!-- 详情/退款 -->
    <ReOfDe
      :VisibleDeRe="VisibleDeRe"
      :DeRe="DeRe"
      :row="row"
      @handleCloseDeRe="VisibleDeRe = false"
      @handleConfirmDeRe="handleConfirmDeRe"
    ></ReOfDe>
    <!-- 服务评价弹窗 -->
    <EvaluationDialog
      :VisibleEvaluation="VisibleEvaluation"
      :orderNumber="orderNumber"
      :handleTypeName="handleTypeName"
      :businessTypeName="businessTypeName"
      :evaluatedName="evaluatedName"
      @handleCloseEvaluation="handleCloseEvaluation"
      @handleSuccess="handleEvaluationSuccess"
    ></EvaluationDialog>
  </div>
</template>

<script>
import {
  auditList, //列表
  companySelectCustomers, //查询客户列表(客户下拉选择)
} from "../../../../../../assets/api/Agency/Enterprise";
import * as API from "@/assets/api/Agency/Enterprise.js";
import HandlePro from "./components/Audit/HandlePro.vue";
import ReOfDe from "./components/Audit/NewDetails.vue";
import UpEstablishment from "./components/Audit/UpEstablishment.vue";
import Table from "./components/IndexCom/Table.vue";
import EvaluationDialog from "../../components/EvaluationDialog.vue"; //服务评价弹框
// 引入分页组件
import paging from "../../../../../../components/paging.vue";
export default {
  data() {
    return {
      screenData: {
        value: null, // 时间
        PayTaxes: "", //企业类型
        input: "", //企业名称
        code: "", //信用代码
        orderNumber:'',
      },
      options: [
        { value: 0, label: "有限公司" },
        { value: 1, label: "个体户" },
        { value: 2, label: "子公司" },
        { value: 3, label: "分公司" },
        { value: 4, label: "其他" },
      ], //企业类型选择
      tableData: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      VisibleUp: false, //注销上传
      VisibleHandlePro: false, //办理
      DeRe: 0, // 0查看  1退款
      Distinguish: 0, //区分什么服务 0注销企业 1注销-银行开户  2注销开户-其他开户
      VisibleDeRe: false, //查看/退款
      VisibleEvaluation: false, //服务评价弹窗
      evaluatedName: "", // 被评价人
      orderNumber: "", //订单号
      handleTypeName: "", //服务类型
      businessTypeName: "", //服务类别
      options1: [], //平台企业的客户
      enterprise: {}, //平台企业的信息
      row: {}, //详情信息
    };
  },
  watch: {},
  components: {
    paging,
    Table,
    HandlePro, //办理
    UpEstablishment, //上传
    ReOfDe,
    EvaluationDialog, //服务评价弹框
  },
  created() {
    this.auditList();
    this.companySelectCustomers();
  },
  destroyed() {},
  methods: {
    // 列表刷新
    Refresh() {
      this.auditList();
    },
    //付款成功
    handleSuccess() {
      this.VisibleUp = false;
      this.VisibleHandlePro = false;
      this.auditList();
    },
    //重置
    handelReset() {
      this.pagingObj.currentPage = 1;
      this.screenData = {
        value: null, // 时间
        PayTaxes: "", //企业类型
        input: "", //企业名称
        code: "", //信用代码
        orderNumber:'',
      };
      this.auditList();
    },
    //搜索
    handelSearch() {
      this.pagingObj.currentPage = 1;
      this.auditList();
    },
    //查询客户列表(客户下拉选择)
    companySelectCustomers() {
      if (!this.$checkActionIpu()) return
      API.companySelectCustomers().then((res) => {
        this.enterprise = res.data.self;
        var arr = res.data.customers;
        arr.unshift(res.data.self);
        this.options1 = arr;
      });
    },
    // 列表
    auditList() {
      // 处理时间
      var time;
      var timeEnd;
      var range = this.screenData.value;
      if (Array.isArray(range) && range.length === 2 && range[0] && range[1]) {
        time = range[0] + " " + "00:00:00";
        timeEnd = range[1] + " " + "23:59:59";
      }
      var data = {
        data: {
          customerCompanyType: this.screenData.PayTaxes, //企业类型
          customerName: this.screenData.input, //企业名称
          customerCreditCode: this.screenData.code, //统一代码

          startTime: time,
          endTime: timeEnd,
          orderNumber:this.screenData.orderNumber
        },
      };
      API.auditList(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        this.tableData = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      });
    },
    // 列表退款弹窗确认
    handleConfirmDeRe(textarea) {
      this.$tool
        .Refund(
          "/global/proxy/auditRequestRefund",
          this.row.orderNumber,
          textarea
        )
        .then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.auditList();
          }
        });
      this.VisibleDeRe = false;
    },
    // 列表点击详情/退款
    handelDetails(num, row) {
      // num 0查看 1退款
      this.row = row;
      this.DeRe = num;
      this.VisibleDeRe = true;
    },
    // 上传设立确定
    handleConfirmUp() {
      this.VisibleUp = false;
    },
    // 上传设立
    handelUp() {
      if (!this.$checkAction()) return
      this.VisibleUp = true;
    },
    // 办理弹窗确认
    handleVHandlePro() {
      this.VisibleHandlePro = false;
    },
    // 办理
    handelAndLeProcess(num, row) {
      if (!this.$checkAction()) return
      // 0办理  1重新提交
      this.VisibleHandlePro = true;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.auditList();
    },
    // 服务评价
    handelEvaluation(row) {
      if (!this.$checkAction()) return;
      this.orderNumber = row.orderNumber;
      this.handleTypeName = "审计"; // 审计服务的服务类型固定为"审计"
      this.businessTypeName = row.businessTypeName;
      this.evaluatedName = (row.evaluatedName || row.beEvaluatedName || row.handlerName || row.staffName || "");
      this.VisibleEvaluation = true;
    },
    // 关闭服务评价弹框
    handleCloseEvaluation() {
      this.VisibleEvaluation = false;
    },
    // 服务评价成功
    handleEvaluationSuccess() {
      this.auditList();
    },
  },
};
</script>

<style scoped lang="less">
.Invoice-body {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 筛选
  .screen {
    margin-top: 10px;
    margin-bottom: 0;
    position: relative;
  }
// 表上方的操作项
  .table-top-Controls {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    align-items: center;
    .action-btn {
      width: 100px;
      height: 35px;
      background: #409eff !important;
      border-color: #409eff !important;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff !important;
      border: none;
      font-family: inherit;
      padding: 0 !important;
      line-height: 1 !important;
      display: inline-flex !important;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .RemainingLocation {
      display: flex;
      flex: 1;
      justify-content: flex-end;
      align-items: center;
      .action-btn {
        margin-left: 20px;
      }
    }
  }
  //   表格
  .Table {
    min-height: 450px;
    margin-top: 30px;
    // border: 1px solid gold;
  }
  // 分页
  .paging-box {
    width: 100%;
    height: 22px;
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    .paging {
      width: 90%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
